export var Unit;
(function (Unit) {
    Unit["PX"] = "px";
    Unit["PERCENT"] = "percent";
})(Unit || (Unit = {}));
export var FixedOutset;
(function (FixedOutset) {
    FixedOutset["TopLeft"] = "TopLeft";
    FixedOutset["TopRight"] = "TopRight";
    FixedOutset["BottomLeft"] = "BottomLeft";
    FixedOutset["BottomRight"] = "BottomRight";
})(FixedOutset || (FixedOutset = {}));
export var Position;
(function (Position) {
    Position["TOP"] = "top";
    Position["LEFT"] = "left";
    Position["BOTTOM"] = "bottom";
    Position["RIGHT"] = "right";
})(Position || (Position = {}));
export var Axis;
(function (Axis) {
    Axis["VERTICAL"] = "vertical";
    Axis["HORIZONTAL"] = "horizontal";
})(Axis || (Axis = {}));
//# sourceMappingURL=style.js.map